import { Injectable, Input } from '@angular/core';
import { Guid } from 'guid-typescript';

@Injectable(
  { providedIn: 'root' }
)

export class BannerService {
  @Input() message: string | undefined;
  @Input() status: BannerServiceStatus | undefined;

  Messages: Message[] = [];

  constructor() { }

  AddMessage(htmlBody: string, status: BannerServiceStatus | undefined, id: Guid | null = null, userCanClear = false) {
    if (id === null) {
      id = Guid.create();
    } else {
      // Remove the existing message
      this.RemoveMessage(id); 
    }

    // Add the new message
    var clearBannerFunc = userCanClear ? () => this.RemoveMessage(id!) : undefined;
    this.Messages.push(new Message(htmlBody, status, id, clearBannerFunc));

    return id;
  }

  RemoveMessage(id: Guid) {
    let index = this.getMessageIndex(id);
    if (index + 1) {
      this.Messages.splice(index, 1);
    }
  }

  private getMessageIndex(id: Guid) {
    return this.Messages.map((m: any) => m.id).indexOf(id);
  }
}

export class Message {
  id: Guid;
  htmlBody: string;
  status: BannerServiceStatus;
  onClearBanner: ((id: Guid) => void) | undefined;

  public get style(): string {
    const colour = this.status.toString();

    return `banner-${colour}`
  }

  constructor(htmlBody: string, status: BannerServiceStatus | undefined, id: Guid, clearBannerFunc: (() => void) | undefined) {
    this.id = id;
    this.status = status ?? BannerServiceStatus.info;
    this.htmlBody = htmlBody;
    this.onClearBanner = clearBannerFunc;
  }
}

export enum BannerServiceStatus {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info'
}
